import { memo } from 'react';
import {
  ListItemText as MUIListItemText, ListItemTextProps,
} from '@mui/material';
import { mergeSX } from '../../../../services/helpers';
import { TYPOGRAPHY_SUBTITLE2 } from '../../../Typography';
import { S4, S5 } from '../../../../theme';

const buildSX = () => ({
  '& .MuiListItemText-primary': {
    ...TYPOGRAPHY_SUBTITLE2,
    color: S5,
  },
  '& .MuiListItemText-secondary': {
    color: S4,
  },
});

const ListItemText = (props: ListItemTextProps) => {
  const { sx, ...restProps } = props;

  return (
    <MUIListItemText
      sx={mergeSX(buildSX(), sx)}
      {...restProps}
    />
  );
};

export default memo(ListItemText);
